
import "@babel/polyfill";
import { polyfill } from 'es6-promise'; polyfill();
import "isomorphic-fetch";

import SaveForm from '../../vendor/vsf/forms/js/SaveForm';
import DeleteForm from '../../vendor/vsf/forms/js/DeleteForm';
import FormsLists from '../../vendor/vsf/forms/js/FormsLists';
import AjaxAction from '../../vendor/vsf/forms/js/AjaxAction';
import Util from '../../vendor/vsf/forms/js/Util';

import Login from '../../vendor/vsf/advanced-login/js/Login';
import ScreenOnSessionExpired from '../../vendor/vsf/advanced-login/js/ScreenOnSessionExpired';
import RememberPassword from '../../vendor/vsf/advanced-login/js/RememberPassword';
import RememberChangePassword from '../../vendor/vsf/advanced-login/js/RememberChangePassword';

// Asigno al namespace global "window" lo que necesito para que se llame en las páginas de la aplicación
window.SaveForm=SaveForm;
window.DeleteForm=DeleteForm;
window.FormsLists=FormsLists;
window.AjaxAction = AjaxAction;
window.Util = Util;

window.Login = Login;
window.ScreenOnSessionExpired = ScreenOnSessionExpired;
window.RememberPassword = RememberPassword;
window.RememberChangePassword = RememberChangePassword;

//Funciones comunes
window.ajaxAction = new AjaxAction();

$(function() {

    window.ajaxAction.initEvents();

    $(".sidebar .nav-dropdown-toggle").click(function(){
        $(this).closest('.nav-dropdown').toggleClass('open');
        return false;
    });

    //Desglosa el menu del link activo
    $(".sidebar .nav-link.active").parents('.nav-dropdown').find('> .nav-dropdown-toggle').click();

    //select2
    $("select:not(.no-select2)").select2({
        theme: "bootstrap",
        minimumResultsForSearch: 10
    });

    //Para hacer que el clear no despliegue las opciones
    $("select").on("select2:clear", function (evt) {
        $(this).on("select2:opening.cancelOpen", function (evt) {
            evt.preventDefault();

            $(this).off("select2:opening.cancelOpen");
        });
    });

    //scroll to top
    $(window).scroll(function () {
        if ($(this).scrollTop() > 400) {
            $('#back-to-top').addClass('show');
        } else {
            $('#back-to-top').removeClass('show');
        }
    });
    $('#back-to-top').on('click', function() {
        $('html, body').animate({scrollTop: 0}, 300);
        return false;
    });

    //scroll to bottom
    $(window).scroll(function () {
        if ($(this).scrollTop() < ($(document).height()-$(window).height())-100) {
            $('#back-to-bottom').addClass('show');
        } else {
            $('#back-to-bottom').removeClass('show');
        }
    });
    $('#back-to-bottom').on('click', function() {
        $('html, body').animate({scrollTop: $(document).height()-$(window).height()}, 300);
        return false;
    });

    //Tooltip
    $('[data-toggle="tooltip"]').tooltip();

    //Sidebar
    $(".btn-sidebar,.sidebar-overlay").click(function() {
        $("body").toggleClass("sidebar-hidden");
    });

});
